import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContentText from '@material-ui/core/DialogContentText';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';

import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { makeStyles } from '@material-ui/core/styles';
import FaceLook from '../../pages/Profile/FaceLook';
import ButtonBase from '../Buttons/ButtonBase';
import AuthButton from '../Buttons/AuthButton';
import {isMobile} from 'react-device-detect';

const useStyles = makeStyles({
  dialog: {
    zIndex: '10000 !important'
  },
});

const styles = (theme) => ({
  dialogActions: {
    //backgroundColor: '#013957',
    justifyContent: 'flex-end',
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: '#013957',
  },
  root: {
      padding: theme.spacing(2),
  }, 
  title: {
    color: '#484848',
    fontSize: 20,
    fontWeight: 'bold',
    margin: 4,
  },
  dialogContent: {
      padding: 0
  }
});


const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <p className={classes.title} >{children}</p>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(1),
    maxWidth: 808,
    maxHeight: isMobile? 'auto':480,
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: 20,
  },
}))(MuiDialogActions);

export default function CoverPhotosModal({ open, handleClose, checkValue, selectCover, cancelCover, coverOnPreview, coversContainer}) {
  const xsMobile = useMediaQuery('(max-width: 400px)');
  const classes = useStyles();

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        scroll="paper"
        fullScreen={isMobile}
        maxWidth='md'
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
        classes={{root:classes.dialog}}
      >
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          Elije tu imagen de portada
        </DialogTitle>
        

        <DialogContent dividers>
        <div className="look_fotoPortada">
            {/* <FaceLook checkValue={checkValue} coverOnPreview={coverOnPreview} />  */}
            {coversContainer}
        </div>
            
        </DialogContent>
        <DialogActions>
          <div style={{width: '100%',display:'flex', justifyContent: xsMobile? 'space-around': 'flex-end'}}>
            <AuthButton variant='outlinedBlue' onClick={cancelCover} style={{width:xsMobile? 144:160}}>
              Cancelar
            </AuthButton>
            <ButtonBase variant='primary' onClick={selectCover} style={{minWidth:xsMobile? 144:160, marginLeft: xsMobile? 0: 40}}>
              Elegir
            </ButtonBase>
          </div>
        </DialogActions>
      </Dialog>
    </>
  );
}
